import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDownloadReport } from './hooks/useDownloadReport';
import { useGetTopbarAddonsItems } from './hooks/useGetTopbarAddonsItems';
import { useMainLayoutTranslate } from './hooks/useMainLayoutTranslate';
import { useMenuOptions } from './hooks/useMenuOptions';
import { useNavListBottom } from './hooks/useNavListBottom';
import { useNavListTop } from './hooks/useNavListTop';
import { useNavMenuFilter } from './hooks/useNavMenuFilter';

export const useMainLayout = () => {
  const navigate = useNavigate();

  const { customLocale } = useMainLayoutTranslate();
  const { getTopbarAddonsItems } = useGetTopbarAddonsItems();
  const { profileMenuOptions } = useMenuOptions();
  const { navListTop: rawNavListTop } = useNavListTop();
  const { navListBottom: rawNavListBottom } = useNavListBottom();
  const { filterMenuItems } = useNavMenuFilter();

  const navListTop = filterMenuItems(rawNavListTop);
  const navListBottom = filterMenuItems(rawNavListBottom);

  useDownloadReport();

  useEffect(() => {
    const container = document.querySelector('.page-animated');
    if (container) {
      container.removeAttribute('style');
    }
  }, [navigate]);

  return {
    navListTop,
    navListBottom,
    profileMenuOptions,
    customLocale,
    getTopbarAddonsItems,
  };
};
